import { render, staticRenderFns } from "./RegionSetup.vue?vue&type=template&id=3a7383d0&scoped=true"
import script from "./RegionSetup.vue?vue&type=script&lang=js"
export * from "./RegionSetup.vue?vue&type=script&lang=js"
import style0 from "./RegionSetup.vue?vue&type=style&index=0&id=3a7383d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7383d0",
  null
  
)

export default component.exports